import { render, staticRenderFns } from "./makeTest.vue?vue&type=template&id=580598f5&scoped=true"
import script from "./makeTest.vue?vue&type=script&lang=js"
export * from "./makeTest.vue?vue&type=script&lang=js"
import style0 from "./makeTest.vue?vue&type=style&index=0&id=580598f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580598f5",
  null
  
)

export default component.exports